<template>
  <div v-loading="loading" class="oa-page">
    <oa-page-header title="关联审批单详情" :description="number" copyable-description back @back="$router.back()"><el-button icon="el-icon-refresh" @click="load">刷新</el-button></oa-page-header>
    <el-alert v-if="error" :title="error" type="error" :closable="false" show-icon />
    <section v-if="!loading && !error" class="oa-panel related-approval-detail">
      <h2>{{ title }}</h2>
      <approve-info :key="id+'-'+revision" :target-id="id" :show-form-info="true" compact interaction-only />
    </section>
  </div>
</template>
<script>
import OaPageHeader from './components/OaPageHeader'
import ApproveInfo from '@/views/crm/components/approveInfo'
import { related } from '@/api/crm/oaBusiness'
export default {
  name:'RelatedApprovalDetail',components:{OaPageHeader,ApproveInfo},
  data(){return {loading:false,error:'',title:'',number:'',revision:0,sequence:0}},
  computed:{id(){return this.$route.params.id}},
  watch:{id:'load'},created(){this.load()},beforeDestroy(){this.sequence++},
  methods:{async load(){const seq=++this.sequence;this.loading=true;this.error='';try{const rows=(await related({ids:this.id})).data||[];if(seq!==this.sequence)return;const row=rows.find(r=>String(r.id)===String(this.id));if(!row)throw Error('审批单不存在或已删除');this.title=row.title||'审批单';this.number=row.number||'历史审批 #'+this.id;this.revision++}catch(e){if(seq===this.sequence)this.error=e.message||'详情加载失败'}finally{if(seq===this.sequence)this.loading=false}}}
}
</script>
<style scoped>.related-approval-detail{padding:24px}.related-approval-detail h2{font-size:20px;margin:0 0 24px;overflow-wrap:anywhere}</style>
